/**
 * Get value of an object property/path even if it's nested
 */
export function getValueByPath(obj, path) {
    const value = path.split('.').reduce((o, i) => o[i], obj)
    return value
}

/**
 * Extension of indexOf method by equality function if specified
 */
export function indexOf(array, obj, fn) {
    if (!array) return -1

    if (!fn || typeof fn !== 'function') return array.indexOf(obj)

    for (let i = 0; i < array.length; i++) {
        if (fn(array[i], obj)) {
            return i
        }
    }

    return -1
}

/**
 * Mobile detection
 * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
 */
export const isMobile = {
    Android: function () {
        return (
            typeof window !== 'undefined' &&
            window.navigator.userAgent.match(/Android/i)
        )
    },
    BlackBerry: function () {
        return (
            typeof window !== 'undefined' &&
            window.navigator.userAgent.match(/BlackBerry/i)
        )
    },
    iOS: function () {
        return (
            typeof window !== 'undefined' &&
            window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
        )
    },
    Opera: function () {
        return (
            typeof window !== 'undefined' &&
            window.navigator.userAgent.match(/Opera Mini/i)
        )
    },
    Windows: function () {
        return (
            typeof window !== 'undefined' &&
            window.navigator.userAgent.match(/IEMobile/i)
        )
    },
    any: function () {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        )
    }
}

export function removeElement(el) {
    if (typeof el.remove !== 'undefined') {
        el.remove()
    } else if (typeof el.parentNode !== 'undefined') {
        el.parentNode.removeChild(el)
    }
}

/**
 * Escape regex characters
 * http://stackoverflow.com/a/6969486
 */
export function escapeRegExpChars(value) {
    if (!value) return value

    // eslint-disable-next-line
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}




export function getHotelDistances(dists) {
  let distances = []
  for (let i in dists) {
    let obj = null
    switch (dists[i].targetKey) {
      case 'location':
        obj = {key: dists[i].targetKey, targetName: 'Destination', distance: dists[i].distance, fas: 'fa-bullseye'}
        distances.push(obj);
        break
      case 'city':
        obj = {key: dists[i].targetKey, targetName: dists[i].targetName, distance: dists[i].distance, fas: 'fa-city'}
        distances.push(obj);
        break
      case 'trainStation' :
        obj = {key: dists[i].targetKey, targetName: dists[i].targetName, distance: dists[i].distance, fas: 'fa-train'}
        distances.push(obj);
        break
      case 'airport':
        obj = {key: dists[i].targetKey, targetName: dists[i].targetName, distance: dists[i].distance, fas: 'fa-plane'}
        distances.push(obj);
        break
    }
  }

  return distances
}

export function getHotelDistance(dists) {
  let distance = 0
  for (let i in dists) {
    if(dists[i].targetKey == 'location') distance = dists[i].distance
  }
  return distance
}

function getBreakfastValues() {
  // TODO: to check
  return {
    inclusive: [
      'inclusive',
      'inclusiveHalfBoard',
      'inclusiveFullBoard',
      'allinclusive'
    ],
    exclusive: [
      'exclusive'
    ]
  }
}

export function getRoomBreakfastInfos(roomOffer) {
  var breakfastValues = getBreakfastValues()
  var isBreakfastIncluded = null
  var breakfastPrice = null

  if (breakfastValues.inclusive.indexOf(roomOffer.breakfastType) !== -1) {
    isBreakfastIncluded = true
  } else if (breakfastValues.exclusive.indexOf(roomOffer.breakfastType) !== -1) {
    isBreakfastIncluded = false
    breakfastPrice = parseFloat(roomOffer.averageBreakfastPriceCustomer.amount)
  }

  return {
    isIncluded: isBreakfastIncluded,
    price: breakfastPrice
  }
}

export function getHotelHotDeals(roomOffers) {
  var nbHotDeals = 0
  var nbOffers = 0

  for( let i in roomOffers ) {
    if (roomOffers.hasOwnProperty(i)) {
      for(let j in roomOffers[i].offers) {
        if (roomOffers[i].offers.hasOwnProperty(j)) {
          nbOffers++
          if (roomOffers[i].offers[j].hotDeal) {
            nbHotDeals++
          }
        }
      }
    }
  }

  return {
    nbHotDeals: nbHotDeals,
    nbOffers: nbOffers
  }
}

export function sortBy(field, reverse, primer) {
  if (field) {
    var key = primer ?
      function(x) {return primer(x[field])} :
      function(x) {return x[field]};

    reverse = !reverse ? 1 : -1;

    return function (a, b) {
      return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    }
  }
}

export function extractHtmlFromString(string) {
  string.toString()

  if (string) {
    return string.replace(/<[^>]*>/g, '')
  }
}

export function countNbNights(from, to) {
  if (!(from instanceof Date)) from = new Date(from)
  if (!(to instanceof Date)) to = new Date(to)

  let oneDay = 24*60*60*1000

  return Math.round(Math.abs((from.getTime() - to.getTime())/oneDay))
}
